import BlainBaseService from "../BlainBaseService";
import cookies from "JS/constants/cookie-names";
import { getCookieObj, setCookieObj } from "JS/utilities/cookie.utils";
import { IAutoPartsVehicle, ICustomerVehicle, IUpdateVehicleRequest } from "JS/types/Automotive";

export interface ICustomerVehicleService {
	getPrimaryVehicle(): Promise<ICustomerVehicle | null>;
	getVehicles(): Promise<ICustomerVehicle[]>;
	addVehicle(vehicle: ICustomerVehicle): Promise<ICustomerVehicle>;
	removeVehicle(vehicleId: number): Promise<void>;
	updateVehicle(req: IUpdateVehicleRequest): Promise<void>
	setPrimaryVehicle(vehicle: ICustomerVehicle): Promise<void>;
	saveAutoPartsVehicle(vehicle: IAutoPartsVehicle): Promise<IAutoPartsVehicle>;
	getAutoPartsVehicle(): Promise<IAutoPartsVehicle | null>;
	removeAutoPartsVehicle(): Promise<void>;
}

export class CustomerVehicleService extends BlainBaseService implements ICustomerVehicleService {
	getPrimaryVehicle(): Promise<ICustomerVehicle | null> {
		const vehicle = getCookieObj<ICustomerVehicle>(cookies.PRIMARY_CUSTOMER_VEHICLE);
		if (vehicle) {
			return Promise.resolve(vehicle);
		}
		return this._httpSvc.get<ICustomerVehicle>('/customer/vehicle/primary/');
	}

	getVehicles(): Promise<ICustomerVehicle[]> {
		return this._httpSvc.get<ICustomerVehicle[]>('/customer/vehicle/');
	}

	addVehicle(vehicle: ICustomerVehicle): Promise<ICustomerVehicle> {
		return this._httpSvc.post<ICustomerVehicle>('/customer/vehicle/', vehicle);
	}

	setPrimaryVehicle(vehicle: ICustomerVehicle): Promise<void> {
		return this._httpSvc.post('/customer/vehicle/primary/', vehicle);
	}

	removeVehicle(vehicleId: number): Promise<void> {
		return this._httpSvc.get(`/customer/vehicle/remove/${vehicleId}/`);
	}

	updateVehicle(req: IUpdateVehicleRequest): Promise<void> {
		return this._httpSvc.post('/customer/vehicle/update', req);
	}

	saveAutoPartsVehicle(vehicle: IAutoPartsVehicle): Promise<IAutoPartsVehicle> {
		return this._httpSvc.post<IAutoPartsVehicle>('/customer/vehicle/autoparts/', vehicle);
	}

	getAutoPartsVehicle(): Promise<IAutoPartsVehicle | null> {
		return this._httpSvc.get<IAutoPartsVehicle | null>('/customer/vehicle/autoparts/');
	}

	removeAutoPartsVehicle(): Promise<void> {
		return this._httpSvc.get('/customer/vehicle/autoparts/remove/');
	}

}